// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__OKWO7 {
  height: 72px;
  width: 100%;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  padding: 24px 4.782vw;
}
.Header_header__OKWO7 .Header_login-shopping-cart-container__hRO\\+t {
  display: flex;
  gap: 96px;
}
.Header_header__OKWO7 .Header_login-shopping-cart-container__hRO\\+t .Header_shopping-cart-icon__eQh\\+B {
  display: flex;
  color: #ffffff;
}
.Header_header__OKWO7 .Header_login-shopping-cart-container__hRO\\+t .Header_login-container__8D5kw {
  width: -moz-fit-content;
  width: fit-content;
}
.Header_header__OKWO7 .Header_login-shopping-cart-container__hRO\\+t .Header_login-container__8D5kw .Header_username__x77JC {
  font-size: 16px;
  padding: 10px;
  color: #ffffff;
}

.Header_clean__pg2xT .Header_logo-container__7tV1h {
  margin-right: auto;
}

.Header_color__65ayv .Header_logo-container__7tV1h {
  margin-left: -8px;
}
.Header_color__65ayv .Header_search-bar__ndf4a {
  display: flex;
  justify-content: center;
  width: 50%;
}

.Header_logo__shVBB {
  width: 164px;
}

.Header_color__65ayv {
  background-color: #1f1f1f;
}

.Header_clean__pg2xT {
  background-color: transparent;
  position: absolute;
}

.Header_cart-tooltip-children__j71B4 {
  width: 250px;
  height: 230px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  margin: 20px 0px;
}
.Header_cart-tooltip-children__j71B4 .Header_cart-tooltip-text__XwsCF {
  font-size: 16px;
}
.Header_cart-tooltip-children__j71B4 .Header_cart-tooltip-img__DHVXs {
  margin: 10px;
  width: 200px;
}
.Header_cart-tooltip-children__j71B4 .Header_cart-tooltip-navigate-button__\\+q8pq {
  display: flex;
  justify-content: center;
  margin: 10px 0px;
}

.Header_title__l\\+wMf {
  font-weight: bold;
  font-size: 20px;
}

.Header_tooltip-log__SPjcN {
  min-width: 150px;
  width: 15vw;
}
.Header_tooltip-log__SPjcN Button {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  font-weight: bold;
  font-size: 16px;
}

@media (min-width: 1300px) {
  .Header_tooltip-log__SPjcN Button {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,WAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,qBAAA;AAFF;AAIE;EACE,aAAA;EACA,SAAA;AAFJ;AAII;EACE,aAAA;EACA,cCXE;ADSR;AAKI;EACE,uBAAA;EAAA,kBAAA;AAHN;AAKM;EACE,eAAA;EACA,aAAA;EACA,cCpBA;ADiBR;;AAUE;EACE,kBAAA;AAPJ;;AAYE;EACE,iBAAA;AATJ;AAYE;EACE,aAAA;EACA,uBAAA;EACA,UAAA;AAVJ;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,yBCrDU;AD0CZ;;AAcA;EACE,6BAAA;EACA,kBAAA;AAXF;;AAcA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAXF;AAaE;EACE,eE1EK;AF+DT;AAcE;EACE,YAAA;EACA,YAAA;AAZJ;AAeE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAbJ;;AAiBA;EACE,iBErFK;EFsFL,eEzFS;AF2EX;;AAiBA;EACE,gBAAA;EACA,WAAA;AAdF;AAgBE;EACE,WAAA;EACA,aAAA;EACA,2BAAA;EACA,iBEjGG;EFkGH,eEvGK;AFyFT;;AAkBA;EAEI;IACE,eE5GK;EF4FT;AACF","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.header {\n  height: 72px;\n  width: 100%;\n  top: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  justify-content: space-between;\n  padding: 24px 4.782vw;\n\n  .login-shopping-cart-container {\n    display: flex;\n    gap: 96px;\n\n    .shopping-cart-icon {\n      display: flex;\n      color: colors.$white;\n    }\n\n    .login-container {\n      width: fit-content;\n\n      .username {\n        font-size: 16px;\n        padding: 10px;\n        color: colors.$white;\n      }\n    }\n  }\n}\n\n.clean {\n  .logo-container {\n    margin-right: auto;\n  }\n}\n\n.color {\n  .logo-container {\n    margin-left: -8px;\n  }\n\n  .search-bar {\n    display: flex;\n    justify-content: center;\n    width: 50%;\n  }\n}\n\n.logo {\n  width: 164px;\n}\n\n.color {\n  background-color: colors.$secondary;\n}\n\n.clean {\n  background-color: transparent;\n  position: absolute;\n}\n\n.cart-tooltip-children {\n  width: 250px;\n  height: 230px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-direction: column;\n  margin: 20px 0px;\n\n  .cart-tooltip-text {\n    font-size: typography.$body-l;\n  }\n\n  .cart-tooltip-img {\n    margin: 10px;\n    width: 200px;\n  }\n\n  .cart-tooltip-navigate-button {\n    display: flex;\n    justify-content: center;\n    margin: 10px 0px;\n  }\n}\n\n.title {\n  font-weight: typography.$bold;\n  font-size: typography.$header-s;\n}\n\n.tooltip-log {\n  min-width: 150px;\n  width: 15vw;\n\n  Button {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    font-weight: typography.$bold;\n    font-size: typography.$body-l;\n  }\n}\n\n@media (min-width: 1300px) {\n  .tooltip-log {\n    Button {\n      font-size: typography.$header-s;\n    }\n  }\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__OKWO7`,
	"login-shopping-cart-container": `Header_login-shopping-cart-container__hRO+t`,
	"shopping-cart-icon": `Header_shopping-cart-icon__eQh+B`,
	"login-container": `Header_login-container__8D5kw`,
	"username": `Header_username__x77JC`,
	"clean": `Header_clean__pg2xT`,
	"logo-container": `Header_logo-container__7tV1h`,
	"color": `Header_color__65ayv`,
	"search-bar": `Header_search-bar__ndf4a`,
	"logo": `Header_logo__shVBB`,
	"cart-tooltip-children": `Header_cart-tooltip-children__j71B4`,
	"cart-tooltip-text": `Header_cart-tooltip-text__XwsCF`,
	"cart-tooltip-img": `Header_cart-tooltip-img__DHVXs`,
	"cart-tooltip-navigate-button": `Header_cart-tooltip-navigate-button__+q8pq`,
	"title": `Header_title__l+wMf`,
	"tooltip-log": `Header_tooltip-log__SPjcN`
};
export default ___CSS_LOADER_EXPORT___;
